import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
// import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
// import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../../Components/ComboBox'
import { Input } from '../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'
import { Box } from '@mui/material'
import { currentDate, convertToMuiDate } from '../../../../utils/helpers'
// import EditIcon from '@mui/icons-material/Edit'
// import ButtonGroup from '@mui/material/ButtonGroup'
// import Tooltip from '@mui/material/Tooltip'
// import { styled } from '@mui/material/styles'
// import UploadFileIcon from '@mui/icons-material/UploadFile'
// import Link from '@mui/material/Link'

// import Stack from '@mui/material/Stack'

export default function SupprimerOperationForm({
  setOperations,
  params,
  operations,
  vehiculesTypes,
  setSelected,
  setSelectedSupprimer,
}) {
  const [open, setOpen] = useState(true)
  // const [moterType, setMotortype] = useState([])
  // const [boatType, setBoatType] = useState([])
  // // const [selectedRow, setSelectedRow] = useState({})
  // const [vehicleType, setVehicleType] = useState({})
  // const [Motortypes, setMotortypes] = useState({})
  // const [boatTypes, setBoatTypes] = useState({})
  const [selectedVehicle, setSelectedVehicle] = useState('')

  const DeleteReason = [
    { label: 'Vente', id: 1 },
    { label: 'Don', id: 2 },
    { label: 'Casse', id: 3 },
    { label: 'Acident', id: 4 },
  ]

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      id: params[0].id,
      DeleteReason: '',
      DateSale: currentDate(),
      SalePrice: '',

      vehicleType: params[0].vehicleType,
      Marque: params[0].Marque,
      Model: params[0].Model,
      Motortype: params[0].Motortype,

      DatePurch: params[0].DatePurch ? convertToMuiDate(params[0].DatePurch) : '',

      boatType: params[0].boatType,
    },
  })

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
    setSelectedSupprimer(false)
  }

  const onSubmit = async (data) => {
    if (data.DeleteReason === null) {
      alert('Please Select Type de véhicule.')
    } else {
      const payload = {
        ...data,
        DeleteReason: data.DeleteReason.label,
        Statut: 'Inactif',
      }
      if (data.Conso === '') {
        payload.Conso = 0
      }
      if (data.Vhpower === '') {
        payload.Vhpower = 0
      }
      if (data.emission === '') {
        payload.emission = 0
      }

      const response = await makePutRequest(
        urls.crudVehiclesOperations + `${data.id}/`,
        payload,
        {},
        true,
      )

      if (response.status === 200) {
        let id = response.data.id
        const filteredOperations = operations.results.filter((v) => v.id !== id)
        const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
          a.id > b.id ? 1 : -1,
        )

        setOperations((operations) => ({
          ...operations,
          results: updatedOperations,
        }))
        // let id = response.data.id
        // const filteredOperations = operations.results.filter((v) => v.id !== id)

        // setOperations((operations) => ({
        //   ...operations,
        //   results: filteredOperations,
        //   count: operations.count - 1,
        // }))
        // setOperations( operations => ( {
        //   ...operations,
        //   results: [ ...operations.results, response.data ],
        //   count: operations.count - 1,
        // } ) )
        handleClose()
      }
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Supprimer véhicules</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('DeleteReason', j)}
              label="Motif"
              data={DeleteReason}
              name="DeleteReason"
              required={true}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="DateSale"
              label="Date"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="SalePrice"
              label="Prix"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Supprimer</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
